module.exports = __webpack_public_path__ + "ly.svg?7722cf0c5e8564a54ba0e51f290b3962";